<template>
    <div class="">          
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="gradation-title-wrapper mb-2">
                    <vs-button color="primary" type="border" radius icon-pack="feather" icon="icon-arrow-left" class="mb-2 mt-4" @click="back"></vs-button>
                    <div class="gradation-title-wrap mt-6">
                        <h1 class="heading">View <span class="text-color-primary">Prospect</span></h1>
                    </div>
                </div>

            </div>
        </div>
        <vx-card title="Interested Property" no-shadow card-border>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Interested In</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.property_type"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Ready to Move-In</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.movie_in_period"></span>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>

        <vx-card title="Prospect Information" class="mt-4" no-shadow card-border>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>First Name</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.first_name"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Last Name</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.last_name"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>DOB</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.date_of_birth"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>SSN</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.ssn"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Email</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.email_address"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Phone Number</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.phone_number"></span>
                        </div>
                    </div>
                </div>   
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Emergency Name</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.emergency_contact_name"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Emergency Phone</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.emergency_contact_phone"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Status</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.status"></span>
                        </div>
                    </div>
                </div>
            </div>     
        </vx-card>

        <vx-card title="Employer Information" class="mt-4" no-shadow card-border>
            <div class="" v-if="prospect.employer !== null">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Employer Name</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view" v-text="prospect.employer.employer_name"></span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Address</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view" v-text="prospect.employer.address.address1"></span>
                            </div>
                        </div>
                    </div>
                </div>                    
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Apartment Number</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view" v-text="prospect.employer.address.address2"></span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Monthly Income</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view">{{prospect.employer.monthly_income| currency('$ ', 2, { thousandsSeparator: ',' })}}</span>
                            </div>
                        </div>
                    </div>
                </div>                                
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Employment Duration</span>
                            </div>
                            <div class="vx-col w-full">
                                <div class="flex">
                                    <span class="block vs-input--view" v-text="prospect.employer.duration"></span>
                                    <span class="w-full ml-2 mt-2"> months.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Occupation</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view" v-text="prospect.employer.occupation"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Supervisor Name</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view" v-text="prospect.employer.supervisor_name"></span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Supervisor Phone</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view" v-text="prospect.employer.supervisor_phone"></span>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="vx-col w-full text-center" v-show="prospect.employer === null">
                <p>No Employer Information Available</p>
            </div>
        </vx-card>
        
        <vx-card title="Other Income Information" class="mt-4" no-shadow card-border>                             
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>SSI</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view">{{prospect.ssi| currency('$ ', 2, { thousandsSeparator: ',' })}}</span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Child Support</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view">{{prospect.child_support| currency('$ ', 2, { thousandsSeparator: ',' })}}</span>
                        </div>
                    </div>
                </div>
            </div>                             
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Other</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view">{{prospect.other| currency('$ ', 2, { thousandsSeparator: ',' })}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
        
        <vx-card title="Prior Housing Information" class="mt-4" no-shadow card-border>                    
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">                        
                    <div class="vx-row mb-6">
                        <div class="vx-col w-5/12 mt-2">
                            <span>Have Ever Been Evicted?</span>
                        </div>
                        <div class="vx-col w-7/12">
                            <span class="block vs-input--view" v-text="prospect.prior_housing_info.evicted ? 'Yes' : 'No'"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-5/12 mt-2">
                            <span>Number of years lived?</span>
                        </div>
                        <div class="vx-col w-7/12">
                            <span class="block vs-input--view" v-text="prospect.prior_housing_info.years"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Address</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.prior_housing_info.address.address1"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Apartment Number</span>
                        </div>
                        <div class="vx-col w-full">
                            <vs-input class="w-full" :name="'prior_apartment_number'" v-model="prospect.prior_housing_info.address.address2" />
                        </div>
                    </div>
                </div>
            </div>                            
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Current Rent</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view">{{prospect.prior_housing_info.current_rent| currency('$ ', 2, { thousandsSeparator: ',' })}}</span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Reason for Leaving</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.prior_housing_info.leaving_reason"></span>
                        </div>
                    </div>
                </div>
            </div>                           
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Landlord/Manager</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.prior_housing_info.landlord_manager"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Phone</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="prospect.prior_housing_info.phone"></span>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>

        <vx-card title="Associated Organization" class="mt-4" no-shadow card-border>
            <div class="w-full"  v-bind:key="index" v-for="(organization, index) in prospect.voucher_organizations">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full" >
                        <div class="vx-row mb-6">
                            <div class="vx-col lg:w-1/3 w-full lg:text-right mt-2">
                                <span>Organization</span>
                            </div>
                            <div class="vx-col lg:w-2/3 w-full">
                                <span class="block vs-input--view" v-text="organization.organization"></span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full" >
                        <div class="vx-row mb-6">
                            <div class="vx-col lg:w-1/3 w-full lg:text-right mt-2">
                                <span>Voucher Amount</span>
                            </div>
                            <div class="vx-col lg:w-2/3 w-full">
                            <span class="block vs-input--view">{{organization.voucher_amount| currency('$ ', 2, { thousandsSeparator: ',' })}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-col w-full text-center" v-show="prospect.voucher_organizations.length == 0">
                <p> No organizations available </p>
            </div>
        </vx-card>

        <vx-card title="Payment Information" class="mt-4" no-shadow card-border>
            <div class="w-full" v-if="prospect.payment_response !== null">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Paid Date</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view" v-text="prospect.payment_response.paid_date"></span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Paid Amount</span>
                            </div>
                            <div class="vx-col w-full">
                                <span class="block vs-input--view">{{prospect.payment_response.paid_amount| currency('$ ', 2, { thousandsSeparator: ',' })}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-col w-full text-center" v-show="prospect.payment_response === null">
                <p>No Payment available</p>
            </div>
        </vx-card>

        <vx-card title="Documents" class="mt-4" no-shadow card-border>
            <div class="vx-row mb-6">
                <div class="vx-col w-full">                    
                    <div class="demo-alignment">
                        <vs-chip transparent color="primary" class="mt-1" v-bind:value="option.id" v-bind:key="option.id" v-for="option in prospect.documents">
                            <a :title="option.file_name" target="PmsAttachement" v-bind:href="option.document_location" type="button" >
                                {{option.file_name}}
                            </a>
                        </vs-chip>
                    </div>                            
                </div>                   
                <div class="vx-col w-full text-center" v-show="prospect.documents.length == 0">
                    <p> No documents available </p>
                </div>
            </div>
        </vx-card>

        <vx-card title="Comments" class="mt-4" no-shadow card-border>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full" v-bind:key="comment" v-for="comment in prospect.comments">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span>Comment</span>
                        </div>
                        <div class="vx-col w-full">
                            <vs-textarea name="comment" disabled v-model="comment.comment" class="w-full" />
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full text-center" v-show="prospect.comments.length == 0">
                    <p> No comments available </p>
                </div>
            </div>
        </vx-card>

    </div>
</template>

<script>
import router from './../../../router.js'
import Prospect from '@/js/prospect.js'

export default {
  name: 'viewProspect',
  data () {
    return {
      prospect: {}
    }
  },
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, path.lastIndexOf('/view'))
    }
  },
  methods: {   
    back () {
      router.go(-1)
    },
    setProspect (prospect) {
      this.prospect = prospect
      console.log('prospect', this.prospect)
    }
  },
  created () {
    this.$vs.loading()
    Prospect.getProspectById(this, this.$route.params.id)
  }
}
</script>